import { Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import Helpers from 'components/Configurator/Viewer/ViewerHelpers';
import { ThemeContext } from 'contexts/themeContext';
import { ISettings } from 'types';

const Viewer = ({ modelPath, children }: { modelPath: string; children?: React.ReactNode }) => {
  const launchViewer = () => Helpers.launchViewer('viewerDiv', modelPath);
  const viewLoader = (logo?: string) => {
    if (!logo) return;
    Helpers.handleCustomLoader(logo);
  };

  const handleLoad = () => {
    if (!modelPath) return;
    launchViewer();
  };

  useEffect(() => {
    handleLoad();
  }, [modelPath]);

  return (
    <ThemeContext.Consumer>
      {(theme: ISettings | null) => {
        const loaderImage = (theme as ISettings)?.headerLogo;
        viewLoader(loaderImage);
        return (
          <Flex
            id="viewerDiv"
            data-testid="viewer"
            sx={{
              flex: 1,
              h: 'full',
              w: 'full',
              pos: 'relative',
              alignContent: 'stretch',
              zIndex: -1,
            }}
          >
            {children}
          </Flex>
        );
      }}
    </ThemeContext.Consumer>
  );
};
export default Viewer;
